import { PageProps } from './Page.interfaces';
import { Page } from './Page';
import useModules from '@/hooks/useListModules/useListModules';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import { Quicklink } from '../Quicklink/Quicklink';
import Image from 'next/image';
import { LeftHandSideMenu } from '../LeftHandSideMenu/LeftHandSideMenu';
import { PublicHeader } from '../Header/PublicHeader/PublicHeader';
import Footer from '../Footer/Footer';
import { useUserContext } from '@/contexts/UserContext';
import { ReactNode } from 'react';

type PublicDashboardPageProps = PageProps & {
  sideMenuChildren?: ReactNode;
};

export const PublicDashboardPage = ({ children, sideMenuChildren, ...pageProps }: PublicDashboardPageProps) => {
  const { user } = useUserContext();
  const { firstIncompleteModule } = useModules();

  function renderInProgressModuleQuicklink() {
    if (!user) return null;

    if (firstIncompleteModule.state === 'loading') {
      return <SkeletonLoader additionalClassNames="w-full h-14 rounded-lg" />;
    }

    if (firstIncompleteModule.state === 'allCompleted') {
      return null;
    }

    return (
      <Quicklink
        link={firstIncompleteModule.module.href}
        surTitle="In progress"
        title={firstIncompleteModule.module.title}
        icon={<Image src="/images/profile-icon.svg" height={30} width={30} alt="User Image" />}
        percentage={firstIncompleteModule.module.percentageComplete}
      />
    );
  }

  return (
    <Page {...pageProps} header={<PublicHeader variant="console" />} footer={<Footer />}>
      <div>
        <LeftHandSideMenu>
          <div className="flex flex-col gap-4">
            <h3 className="h4">Quicklinks</h3>
            <ul className="list-style-none m-0 flex flex-col gap-2">
              {renderInProgressModuleQuicklink()}
              <Quicklink
                link="/get-help-and-support"
                title="Resources"
                icon={<Image src="/images/resources-icon.svg" height={30} width={30} alt="User Image" />}
              />
              <Quicklink
                link="/exercise"
                title="Exercises"
                icon={<Image src="/images/exercise-toolbox-icon.svg" height={30} width={30} alt="User Image" />}
              />
            </ul>
            {sideMenuChildren}
          </div>
        </LeftHandSideMenu>
        <div>{children}</div>
      </div>
    </Page>
  );
};
